import { GetB2bFullyManagedPlanContributionsOneResponse } from '@Common/types/b2b/orders';

export const fullyManagedPlanContributionsTranslations = {
  fields: {
    id: 'ID',
    b2b_campaign_id: 'ID Opération',
    b2b_company_id: 'ID Entreprise',
    savings_funds_request_id: 'ID Appel de fonds',
    matching_contribution_id: 'ID Abondement',
    b2b_company_plan_id: 'ID Plan',
    b2b_fully_managed_allocation_id: 'ID allocation',
    voluntary_deposit_fully_managed_plan_contribution_id: 'ID Contribution VP',
    user_id: 'ID Utilisateur',
    status: 'Statut',
    contribution_type: 'Contribution type',
    total_gross_amount: 'Montant brut',
    user_currency_amount: 'Montnant net',
    fee_amount: 'Montant frais',
    tax_amount: 'Montant taxe',
    tax_info: 'Information taxe',
    paid_at: 'Payé à',
    created_at: 'Créé à',
    updated_at: 'Mis à jour à',
    user_currency: 'Devise',
  } satisfies Record<keyof GetB2bFullyManagedPlanContributionsOneResponse, string>,
  sections: {
    title: 'Abondement',
  },
};
